import { useTranslation } from 'react-i18next';
import { Icon } from './shared/Icon';

/**
 * Live could not read tonight's service (for example a local run without an
 * aleno token, which the server answers with 503). Said inline, in the
 * canvas: the navigation and the context bar stay, so every other screen
 * still opens.
 */
export function LiveUnavailable({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  const { t } = useTranslation('live');
  const title = t('unavailable.title');
  // The server's reason often starts with the same words as the heading.
  const reason = message.toLowerCase().startsWith(`${title.toLowerCase()}:`)
    ? message.slice(title.length + 1).trim()
    : message;
  const shown = reason ? reason.charAt(0).toUpperCase() + reason.slice(1) : '';
  return (
    <section className="live-unavailable" role="alert" aria-labelledby="live-unavailable-title">
      <span className="live-unavailable-ic" aria-hidden>
        <Icon name="info" size={18} />
      </span>
      <div className="live-unavailable-copy">
        <h2 id="live-unavailable-title">{title}</h2>
        <p>{shown || t('unavailable.body')}</p>
        <p className="live-unavailable-next">{t('unavailable.next')}</p>
      </div>
      {onRetry ? (
        <button type="button" className="live-unavailable-retry" onClick={onRetry}>
          <Icon name="refresh" size={13} />
          {t('unavailable.retry')}
        </button>
      ) : null}
    </section>
  );
}
